import type { FaireProductEntity } from "../../entity_types/product";

export const p_cp0pv7pg: FaireProductEntity = {
  token: "p_cp0pv7pg",
  type: "product",
  name: "Disco Ball Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f7b6208e7b0be6dadbe750075c44b6b36c92e4870c09e1e3c29589e6a60ac403.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/cf35b9629b9710b14fa195f12ee00f910880db92f36ff761f684f026ffbe02a2/1528335495.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:42.220Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
